export const formatMediaList = (array = [], type) => {
  return array.map(elem => {
    return {
      mediaUrl: elem,
      mediaType: type,
      original: elem.includes('original'),
      processed: elem.includes('processed'),
      thumbnails: elem.includes('thumbnails')
    };
  });
};